import { faEarthAmericas } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useContext } from 'react';

import MenuPlan from 'classes/MenuPlan/Search/MenuPlan';
import { TenantNodeTree } from 'components/desktop/MenuPlan/Search/PublishingModal/TenantNodeTree';
import useState from 'components/desktop/MenuPlan/Search/PublishingModal/useState';
import Modal from 'components/desktop/_general/Modal/Modal';
import { useTenantNodes } from 'hooks/useTenantNodes';
import useTranslation from 'hooks/useTranslation';

interface IProps {
	selectedMenuPlanId: string | null;
	setSelectedMenuPlanId: (input: string | null) => void;
	reloadMenuPlanList: () => void;
	menuPlan: MenuPlan | undefined;
}

const PublishingModal = (props: IProps) => {
	const { state, handlers } = useState();
	const { t } = useTranslation();
	const { nodes, isLoading, error } = useTenantNodes();
	const { initializeWithoutDetails: initializeShoppingCartsWithoutDetails } =
		useContext(ShoppingCartsContext);

	return (
		<Modal
			isOpen={Boolean(props.selectedMenuPlanId)}
			close={() => {
				props.setSelectedMenuPlanId(null);
			}}
			size={'sm'}
			bodyContent={
				<div>
					{isLoading ? (
						<div className="text-center">
							<div className="spinner-border" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
						</div>
					) : error ? (
						<div className="alert alert-danger">{error}</div>
					) : nodes.length > 0 ? (
						<TenantNodeTree
							nodes={nodes}
							selectedNodeIds={state.selectedLocationGroup}
							onNodeToggle={handlers.toggleString}
						/>
					) : (
						<div>{t('_general:NOT_SPECIFIED')}</div>
					)}
				</div>
			}
			headerIcon={<FontAwesomeIcon icon={faEarthAmericas}></FontAwesomeIcon>}
			buttonOutlined={{
				label: t('_general:BTN_LEAVE'),
				onClick: () => props.setSelectedMenuPlanId(null),
			}}
			buttonFull={{
				label: t('_general:PUBLISH'),
				onClick: async () => {
					if (!props.selectedMenuPlanId) return;
					await handlers.sendToApi({
						menuPlanId: props.selectedMenuPlanId,
					});
					if (props.menuPlan) {
						props.menuPlan.publishStatus = 'Published';
					}
					initializeShoppingCartsWithoutDetails();
					props.reloadMenuPlanList();
					props.setSelectedMenuPlanId(null);
				},
			}}
			headerText={t('_general:PUBLISH')}
		></Modal>
	);
};

export default PublishingModal;
